import { render, staticRenderFns } from "./WildlifeForm.vue?vue&type=template&id=5c61e8a2&scoped=true"
import script from "./WildlifeForm.vue?vue&type=script&lang=js"
export * from "./WildlifeForm.vue?vue&type=script&lang=js"
import style0 from "./WildlifeForm.vue?vue&type=style&index=0&id=5c61e8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c61e8a2",
  null
  
)

export default component.exports